import { graphql } from '@gql';

export const GET_STANDARDS = graphql(`
    query GetStandards {
        standards {
            totalCount
            edges {
                node {
                    ...StandardWithProfile
                }
            }
        }
    }
`);

export const GET_STANDARDS_WITH_REQUIREMENTS = graphql(`
    query GetStandardsWithRequirements {
        standards {
            edges {
                node {
                    ...StandardWithProfile
                    requirements {
                        ...RequirementBasicFragment
                    }
                }
            }
        }
    }
`);

export const GET_ALL_STANDARDS_RICH = graphql(`
    query GetAllStandardsRich {
        standards {
            edges {
                node {
                    ...RichStandardFragment
                }
            }
        }
    }
`);

export const GET_SINGLE_STANDARD_NAME_ONLY = graphql(`
    query GetStandardName($sid: ID!) {
        standards(where: { id: $sid }) {
            edges {
                node {
                    name
                }
            }
        }
    }
`);

export const GET_ALL_STANDARD_NAMES = graphql(`
    query GetStandardNames {
        standards {
            edges {
                node {
                    ...StandardFragment
                }
            }
        }
    }
`);
